// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__Nidse","qualcommimg":"SponsorsSection_qualcommimg__H95W0"};